import { v4 as uuidv4 } from 'uuid';

import Tasks from 'APP/Tasks';
import { PayloadType } from 'APP/model/message/messageModel.types';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

// Todo remove when the articles we'll be refactored
// This is old functionality moved from global messaging tasks

export function getArticlePayloadClass(data) {
  const getPayload = (type, data) => {
    switch (type) {
      case PayloadType.RichText:
        return createTextPayload(data);
      case PayloadType.Image:
        return createImagePayload(data);
      case PayloadType.Location:
        return createLocationPayload(data);
      case PayloadType.AudioMessage:
        return createAudioPayload(data);
      case PayloadType.Video:
        return createVideoPayload(data);
      case PayloadType.File:
        return createFilePayload(data);
    }
  };

  return new ArticlePayload({
    title: data.title,
    payloads: data.payloads.map((item, idx) => {
      if (item.type) {
        return {
          id: item.id || uuidv4(),
          order: item.order || idx,
          payloadType: PayloadType.ContainerOrdered,
          payload: getPayload(item.type, item.data),
        };
      }

      return {
        id: item.id || uuidv4(),
        order: item.order || idx,
        payloadType: PayloadType.ContainerOrdered,
        payload: getPayload(item.payload.payloadType, item.payload),
      };
    }),
  });
}

function createTextPayload(data) {
  return {
    payloadType: PayloadType.RichText,
    text: data.text.trim(),
    linkPreview: data.linkPreview,
    linkPreviewCancelled: data.linkPreviewCancelled,
    userMentions: Tasks.messaging.getMentionsDataFromText(data.text),
  };
}

function createLocationPayload(data) {
  return {
    payloadType: PayloadType.Location,
    latitude: data.latitude,
    longitude: data.longitude,
  };
}

function createImagePayload(data) {
  const imageData = data.file;

  return {
    payloadType: PayloadType.Image,
    fileName: imageData?.name || data.fileName,
    fileSize: imageData?.size || data.fileSize,
    graphicSize: data.graphicSize,
    localPreview: data.localPreview,
    mimeType: imageData?.type || data.mimeType,
    userFile: imageData,
    comment: data.comment || '',
    url: data.url || null,
  };
}

function createVideoPayload(data) {
  const imageData = data.file;

  return {
    payloadType: PayloadType.Video,
    fileName: imageData?.name || data.fileName,
    fileSize: imageData?.size || data.fileSize,
    graphicSize: data.graphicSize,
    localPreview: data.localPreview,
    mimeType: imageData?.type || data.mimeType,
    userFile: imageData,
    comment: data.comment || '',
    url: data.url || null,
    previewUrl: data.previewUrl,
  };
}

function createFilePayload(data) {
  const fileData = data.file;

  return {
    payloadType: PayloadType.File,
    fileName: fileData?.name || data.fileName,
    fileSize: fileData?.size || data.fileSize,
    mimeType: fileData?.type || data.mimeType,
    userFile: fileData,
    comment: data.comment || '',
    url: data.url || null,
  };
}

function createAudioPayload(data) {
  const fileData = data.file;

  return {
    payloadType: PayloadType.AudioMessage,
    fileName: fileData?.name || data.fileName,
    fileSize: fileData?.size || data.fileSize,
    mimeType: fileData?.type || data.mimeType,
    userFile: fileData,
    comment: data.comment || '',
    url: data.url || null,
    duration: data.duration || null,
  };
}
